export const tableSchemas = [
  {
    prop: 'id',
    label: '广告组id',
    minWidth: 150
  },
  {
    prop: 'tenantId',
    label: '所属租户id',
    minWidth: 100
  },
  {
    prop: 'clinicId',
    label: '所属诊所id',
    minWidth: 100
  },
  {
    prop: 'name',
    label: '标题',
    minWidth: 180
  },
  {
    prop: 'type',
    label: '广告组类型',
    minWidth: 180
  },
  {
    prop: 'note',
    label: '描述',
    minWidth: 120
  },
  {
    prop: 'action',
    label: '操作',
    minWidth: 220,
    btnArr: ['info', 'update', 'delete']
  }
]

/* eslint-disable */
export const newsGroupType = {
  [1]: '公告',
  [2]: '小程序轮播图',
  [3]: '患者端广告轮播图'
}

// 基础设置 form
export const formSchemas = [
  {
    field: 'name',
    defaultValue: '',
    component: 'Input',
    label: '标题',
    placeholder: '请输入标题',
    rules: [
      {
        required: true,
        message: '标题不能为空'
      }
    ]
  },
  {
    field: 'note',
    defaultValue: '',
    component: 'InputTextArea',
    label: '描述',
    placeholder: '请输入描述信息',
    rules: []
  },
  {
    field: 'type',
    defaultValue: 1,
    component: 'Radio',
    label: '广告组类型',
    radioArr: [
      {
        value: 1,
        label: '公告'
      },
      {
        value: 2,
        label: '小程序轮播图'
      },
      {
        value: 3,
        label: '患者端广告轮播图'
      }
    ]
  },
  {
    field: 'clinic',
    defaultValue: '',
    component: 'Cascader',
    label: '诊所',
    placeholder: '请选择诊所',
    rules: [
      {
        required: true,
        message: '租户不能为空'
      }
    ]
  }
]

// 基础设置 form
export const authFormSchemas = [
  {
    field: 'authTime',
    defaultValue: '',
    component: 'DateInterval',
    label: '服务时间',
    rules: [
      {
        required: true,
        message: '授权时间不能为空'
      }
    ]
  },
  {
    field: 'lastPayTime',
    defaultValue: '',
    component: 'Date',
    label: '最后续费时间',
    placeholder: '请选择最后续费时间',
    rules: [
      {
        required: true,
        message: '最后续费时间不能为空'
      }
    ]
  },
  {
    field: 'ybCode',
    defaultValue: '',
    component: 'Input',
    label: '医保编码',
    rules: []
  },
  {
    field: 'moduleConfig',
    defaultValue: '',
    component: 'Radio',
    label: '授权功能',
    placeholder: '请选择授权功能',
    radioArr: [],
    rules: [{ required: true, message: '最后续费时间不能为空' }]
  }
]

// 修改设置 form
export const updateFormSchemas = [
  {
    field: 'name',
    defaultValue: '',
    component: 'Input',
    disabled: true,
    label: '租户名'
  },
  {
    field: 'clinicName',
    defaultValue: '',
    component: 'Input',
    disabled: true,
    label: '诊所名'
  },
  {
    field: 'type',
    defaultValue: 1,
    component: 'Radio',
    label: '所属模块类型',
    disabled: true,
    placeholder: '请选择所属模块类型',
    radioArr: [
      {
        label: '平台管理系统',
        value: 1
      },
      {
        label: 'his管理系统',
        value: 2
      }
    ],
    rules: []
  },

  {
    field: 'authTime',
    defaultValue: '',
    component: 'DateInterval',
    label: '授权时间',
    placeholder: '请选择授权时间',
    radioArr: [],
    rules: [
      {
        required: true,
        message: '授权时间不能为空'
      }
    ]
  },
  {
    field: 'moduleConfig',
    defaultValue: '',
    component: 'Radio',
    label: '应用配置',
    placeholder: '请选择应用配置',
    disabled: true,
    radioArr: [],
    rules: [
      {
        required: true,
        message: '请选择一个应用不能为空'
      }
    ]
  }
]

export const options = []
